var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollableContainer"},[_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5594360","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/shared-components/scrollable-container/scrollable-container.html
// module id = null
// module chunks = 